// Printer types for Settings. Labels follow the POS Add Printer list.
export const PRINTER_TYPES = {
  internal: 'internal',
  epson: 'epson',
  epson_40: 'epson_40',
  epson_48: 'epson_48',
  epson_220: 'epson_220',
  ordersco_xprinter: 'ordersco_xprinter',
  aclas: 'aclas',
  xprinter: 'xprinter',
  generic_escpos: 'generic_escpos',
  other: 'other',
  star: 'star',
  starsp700: 'starsp700',
  landi: 'landi',
  landypos: 'landypos',
  landipos: 'landipos',
};

export const PRINTER_TYPE_LABELS = {
  internal: 'Internal',
  epson: 'Epson',
  epson_40: 'Epson 40',
  epson_48: 'Epson 48',
  epson_220: 'Epson U220',
  ordersco_xprinter: 'Orders.co',
  aclas: 'Aclas',
  xprinter: 'Xprinter',
  generic_escpos: 'Generic ePOS',
  other: 'Other',
  star: 'Star',
  starsp700: 'Star SP700',
  landi: 'Landi',
  landypos: 'landypos',
  landipos: 'landipos',
};

export const getPrinterTypeLabel = (type) =>
  PRINTER_TYPE_LABELS[type] || type || '';
